




























import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import NavBarList from './NavBarList.layout.vue';
import NavBarAccount from './NavBarAccount.layout.vue';
import componentsRouter from '@/router/modules/component';

@Component({
  name: 'Navbar',
  components: {
    NavBarList,
    NavBarAccount,
  },
})
export default class NavBar extends BaseComponent {
  private items = componentsRouter;
}
